import { Container, Title, CardLayout } from "./styles";

export const CardContainer = ({ title, columns = 1, className, children }) => (
  <Container className={className}>
    <Title>{title}</Title>
    <CardLayout columns={columns}>{children}</CardLayout>
  </Container>
);
